export default {
  text: 'Dit restaurant is gesuspendeerd. Neem contact op met uw contactpersoon of stuur ons een bericht op <a>{{supportEmail}}</a> als u het wilt herstellen',
};
